import axios from "@/utils/axios.js";
/**
 * 获取积分明细
 * {"agentID":经纪人ID}
 */
export async function getpoints(params) {
  return axios.post("/pointsLog/getPointsLogNew", params);
}

/**
 * 获取积分规则
 * @param {number} params
 * 写死10
 */
export async function getrules(status) {
  return axios.post(
    `/points/pointsList/${status}`,
    {},
    {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }
  );
}
/**
 * 获取优币
 *@param {object} params
 * {"agentID":经纪人ID}
 */
export async function getuCurrency(params) {
  return axios.post("/pointsLog/getExchangeRecords", params);
}
